<template>
  <div>
    <section>
      <div id="timeline" class="timeline">
        <h1>Plan your launch timeline and strategy</h1>

        <div
          v-motion
          class="check-your-prices"
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        >
          <div class="left-part">
            <h1>Pick Sulit Prices</h1>
            <p>
              Make sure your products are affordable for your audience. Set
              exciting prices to grow your customer base. Deals deals deals.
              <br />
              <br />
              Upon launch, you can also offer
              <span>introductory discounts</span>
              to acquire more customers.
            </p>
          </div>
          <div class="right-part">
            <img src="img/pink-sulit-price.png" alt="Avatar" class="image" />
          </div>
        </div>

        <div
          v-motion
          class="check-your-prices"
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        >
          <div class="left-part">
            <h1>Tease and hype it up!</h1>
            <p>
              Get your viewers and followers excited for your store launch by
              setting a launch date and doing pre-launch promotions.
            </p>
            <ul>
              <li>Countdown</li>
              <li>Teasers</li>
            </ul>
          </div>
          <div class="right-part">
            <img src="img/tease-up.png" alt="Avatar" class="image" />
          </div>
        </div>

        <div
          v-motion
          class="check-your-prices"
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        >
          <div class="left-part">
            <h1>Promote your store!</h1>
            <p>
              Put your store link on your social media profiles, content
              description, video banners - everywhere!
            </p>
          </div>
          <div class="right-part">
            <img src="img/promote.png" alt="Avatar" class="image" />
          </div>
        </div>

        <div
          v-motion
          class="check-your-prices"
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        >
          <div class="left-part">
            <h1>Maximize our tools to engage with your audience</h1>
            <ul>
              <li>Email blasts for your announcements and new products.</li>
              <li>
                Discord integration to allow your subscribers to enter your
                server.
              </li>
            </ul>
          </div>
          <div class="right-part">
            <img src="img/engage.png" alt="Avatar" class="image" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
section {
  width: 100%;
  padding: 3rem 2rem;
  text-align: center;

  background-image: url('/img/timeline-wallpaper.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.timeline {
  max-width: 50rem;
  margin: auto;
  text-align: center;
  padding: 3rem 0;
}

.timeline h1 {
  font-size: 3.5rem;
  font-weight: 700;
  color: #ff5f8f;
}

.check-your-prices {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  align-items: center;
  gap: 3rem;
  padding: 3.5rem;
  margin-top: 3rem;
  border-radius: 5px;
  background-color: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.check-your-prices img {
  pointer-events: none;
}

.left-part {
  text-align: left;
}

.left-part h1 {
  font-size: 2rem;
  color: black;
}

.left-part p,
.left-part ul li {
  font-weight: 600;
  opacity: 0.5;
  line-height: 1.5;
}

.right-part img {
  width: 100%;
  display: block;
  margin: auto;
}

@media only screen and (max-width: 800px) {
  .check-your-prices {
    grid-template-columns: 1fr;
    padding: 2rem;
  }

  .timeline h1 {
    font-size: 2.5rem;
  }

  .left-part h1 {
    font-size: 1.5rem;
  }

  .right-part img {
    width: 85%;
  }
}
</style>
